import TableCellText from "ds/components/Table/Row/CellText";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { Session } from "types/generated";

const SessionsTableUserCell = ({
  item: session,
  ...cellProps
}: TableSimpleCellProps<Pick<Session, "login">>) => {
  return (
    <TableSimpleCell {...cellProps} role="rowheader">
      <TableCellText>{session.login}</TableCellText>
    </TableSimpleCell>
  );
};

export default SessionsTableUserCell;
